module.exports = __webpack_public_path__ + "static/media/logo-connex-lim.92060658.gif";